<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="500"
      size="mini"
      resizable
      border
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :radio-config="{ highlight: true, trigger: 'row', strict: false }"
      @radio-change="(e) => $emit('radio-change', e)"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>

      <template v-slot:shippingMarkContext="{ row }">
        <div class="shippingMark" v-if="row.shippingMarkType">
          <span class="shippingMark_text">
            {{ row.shippingMarkText }}
          </span>
          <span class="shippingMark_image">
            <el-image
              style="width: 80px; height: 80px"
              fit="contain"
              :src="
                row.shippingMarkImageUrl
                  ? row.shippingMarkImageUrl
                  : '/image/static/img/nopic.jpg'
              "
              :preview-src-list="[
                row.shippingMarkImageUrl
                  ? row.shippingMarkImageUrl
                  : '/image/static/img/nopic.jpg',
              ]"
            >
            </el-image>
          </span>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns.js'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
      },
      tableColumns: tableColumns(this),
    }
  },
}
</script>
<style lang="scss" scoped>
.shippingMark {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  .shippingMark_text {
    margin-right: 10px;
    font-size: 30px;
  }
}
</style>
